import { api } from './GenerateReport.generated'
import {
    Box,
    Button,
    Heading,    
    Select,
    Table,
    Tbody,
    Td,    
    Tr,
    FormControl,
    SimpleGrid,
    ButtonGroup,
    Input,
    FormLabel,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Checkbox,
    CheckboxGroup,
    Stack  
} from '@chakra-ui/react';

import { useEffect, useState } from 'react';
import {  FaFileExcel } from "react-icons/fa";
import { useSearchEmployeeQuery } from 'modules/admin/api';
import { useContractsQuery, usePositionsQuery } from 'modules/admin/api';
import debounce from "lodash/debounce";
import { useExportEmployees } from './hooks';
import { api as SubAreas } from "../../../../SubAreas";
import { AutocompleteInput } from 'components/AutocompleteInput';

export function GenerateReport() {

    
  

  
    const [selectedValues, setSelectedValues] = useState<string>("cargo");

    const formatDate = (date: any) => date.toISOString().split('T')[0];
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const [startDate, setStartDate] = useState(formatDate(yesterday));
    const [endDate, setEndDate] = useState(formatDate(tomorrow));
    
    const [selectArea, setSelectArea] = useState<string>("");
    const [selectSubArea, setSelectSubArea] = useState<string>("");

    const [dataRepor, setDataRepor] = useState<boolean>(false);
    const [dataSalary, setDataSalary] = useState<boolean>(false);

    // TODO: Fix en formulario de empleados
    usePositionsQuery();
    useContractsQuery();
    
    const { isExporting, relationData, setCaptureInfo, captureInfo, customExportSalary, customExportRole, selectedCheck, setSelectedCheck } = useExportEmployees();


    const { data: dataSubAreas } = SubAreas.useSubAreasQuery();
    const { data: dataPositions } = usePositionsQuery();
 
    useEffect(()=>{       
        if(selectedValues === "cargo"){
            setSelectedCheck([...selectedCheck,"area"])
        }else{           
            setSelectedCheck(selectedCheck.filter(item => item !== "area"));   
        }
    },[selectedValues])


    const [searchKeyword, setSearchKeyword] = useState<string>("");
    const debounceSetSearchKeyword = debounce(setSearchKeyword, 800);

    const [getSalaryLogs, { data: reportData }] = api.useLazyGetSalaryLogsQuery()

    const [getRoleLogs, { data: reportLogsData}] = api.useLazyGetRoleLogsQuery()

    useEffect(() => {
        if (reportData?.salaryLogs) {
            const filteredSalaryLogs = filterEmployeeFields(reportData?.salaryLogs, selectedCheck);
            setCaptureInfo(filteredSalaryLogs);            
        }
    }, [reportData]);

    useEffect(() => {
        if (reportLogsData?.roleChangeLogs) {
            const filteredReportLogs = filterEmployeeFields(reportLogsData?.roleChangeLogs, selectedCheck);
            if (selectArea !== "" || selectSubArea !== "") {                
                const filtered = filteredReportLogs.filter((item: any) => {
                    const matchArea = selectArea === "" || item.current === selectArea;
                    const matchSubArea = selectSubArea === "" || item.current === selectSubArea;
                    return matchArea && matchSubArea;
                  });                  
                setCaptureInfo(filtered)
            } else {
                setCaptureInfo(filteredReportLogs)
            }            
        }
    }, [reportLogsData])

    useEffect(() => {
        if (reportData?.salaryLogs) {
            const filteredSalaryLogs = filterEmployeeFields(reportData?.salaryLogs, selectedCheck);
            setCaptureInfo(filteredSalaryLogs);
            
        }else{
          setCaptureInfo({employees: {
            id: "",
            subArea: "",
            area: ""
          }})  
        }
        
    }, [selectArea, selectSubArea, selectedCheck, dataSalary, startDate, endDate, selectedValues])

    useEffect(() => {
        if (reportLogsData?.roleChangeLogs) {
            const filteredReportLogs = filterEmployeeFields(reportLogsData?.roleChangeLogs, selectedCheck);
            if (selectArea !== "" || selectSubArea !== "") {
                
                const filtered = filteredReportLogs.filter((item: any) => {
                    
                    const matchArea = selectArea === "" || item.current === selectArea;
                    const matchSubArea = selectSubArea === "" || item.current === selectSubArea;
                    
                    return matchArea && matchSubArea;
                  });
                  
                setCaptureInfo(filtered)
            } else {
                setCaptureInfo(filteredReportLogs)
            }
            
        }else{
            setCaptureInfo({employees: {
            id: "",
            subArea: "",
            area: ""
          }}) 
        }
       
    }, [selectArea, selectSubArea, selectedCheck, dataRepor, startDate, endDate, selectedValues])


    const handleFetchLogs = async () => {

     

        if (!startDate || !endDate) {
            return;
        }

        if (selectedValues === "salario") {
            if (!reportData || reportData?.salaryLogs?.length ===0 ) {
                getSalaryLogs({
                    input: {
                        filters: {
                            startDate: new Date(startDate).toISOString(),
                            endDate: new Date(endDate).toISOString(),
                            fields: [],
                            logableId: dataSearch?.employees[0]?.id ?? "",
                        },
                        skip: 0,
                        take: 10
                    }
                });
            }

            setDataSalary(!dataSalary)

        } else {

            if (!reportLogsData || reportLogsData?.roleChangeLogs.length===0) {
                
                getRoleLogs({
                    input: {
                        filters: {
                            startDate: new Date(startDate).toISOString(),
                            endDate: new Date(endDate).toISOString(),
                            subAreaId: captureInfo?.employees[0]?.subArea ?? "",
                            logableId: dataSearch?.employees[0]?.id ?? "",
                            positionId: captureInfo?.employees[0]?.area ?? ""
                        },
                        skip: 0,
                        take: 10
                    }
                });
            }

            setDataRepor(!dataRepor)
        }       
    };

 


  

  

    const { data: dataSearch, isFetching: isLoadingSearch } =
        useSearchEmployeeQuery(
            { search: searchKeyword },
            { skip: searchKeyword === "" }
        );

    useEffect(() => {
        
    }, [selectedCheck])

    function filterEmployeeFields(logs: any[], allowedFields: string[]) {



        return logs.map(log => {
            const filteredEmployee: any = {};

            allowedFields.forEach(field => {
                if (field === "area" || field === "subArea" || field === "contract" || field === "position") {
                    
                    if (log.employee[field]) {
                        filteredEmployee[field] = log.employee[field].name;
                    }
                } else {
                    if (log.employee[field] !== undefined) {
                        filteredEmployee[field] = log.employee[field];
                    }
                }
            });

            return {
                ...log,
                employee: filteredEmployee,
            };
        });
    }


    const ChangeRole = (name: string) => {
        setSelectArea(name);
    }

    const ChangeSubRole = (name: string) => {
        setSelectSubArea(name)
    }


    return (
        <Box p={5} bg="gray.50" margin={"auto"} mb={12} padding={"40px 160px"}>
            <Heading size="xs" fontSize={"20px"}>Reporte de Empleados</Heading>
            <Heading  mt="5" size="xs">Buscar empleado</Heading>
            <AutocompleteInput
                bg="white"
                 mb="5" mt="5"
                suggestionValueField="id"
                suggestionLabelField="fullName"
                value={searchKeyword}
                
                onChange={debounceSetSearchKeyword}
                loading={isLoadingSearch}
                suggestions={
                    dataSearch?.employees.map((it) => ({
                        fullName: `${it.idNumber} ${it.firstName} ${it.lastName}`,
                        ...it,
                    })) ?? []
                }
            />
            <Table variant="striped" size="md" bg="white" mb={"5"}>
                <Tbody>
                    <Tr>
                        <Td>Tipo de Reporte</Td>
                        <Td>
                            <Select onChange={(e) => setSelectedValues(e.target.value)}>
                                <option value={"cargo"}>
                                    Reportes de Empleados por Cargo
                                </option>
                                <option value={"salario"}>
                                    Reportes de Empleados por Salario
                                </option>
                            </Select>
                        </Td>
                    </Tr>
                </Tbody>
            </Table>
            <Heading size="xs">Campos editables por el empleado</Heading>
            {selectedCheck?.includes("area") &&
                <FormControl
                    as={SimpleGrid}
                    columns={{ base: 2, lg: 4, xl: 4 }}
                    bg="white"
                    p="5"
                    mt="5"
                    gap={20}
                    alignItems={"center"}
                >

                    <FormLabel htmlFor="startField">
                        Cargo
                    </FormLabel>
                    <Select value={selectArea}
                        onChange={
                            (e) => ChangeRole(e.target.value)

                        }
                        id="positionId">
                        {selectedValues==="cargo"?
                                <option value="">Seleccione un cargo</option>
                                : 
                                <option selected  value="">Seleccione un cargo</option>
                            }
                        {dataPositions?.positions.map((it) => (
                            <option key={it.id} value={it.name}>
                                {it.name}
                            </option>
                        ))}
                    </Select>
                    <FormLabel htmlFor="startField">
                        Sub Area
                    </FormLabel>
                    <FormControl
                        isRequired
                    >
                        <Select value={selectSubArea} onChange={(e) => ChangeSubRole(e.target.value)} id="subAreaId" >
                            {selectedValues==="cargo"?
                                <option value="">Seleccione una sub area</option>
                                : 
                                <option selected  value="">Seleccione una sub area</option>
                            }
                            
                            {dataSubAreas?.subAreas.map((it) => (
                                <option key={it.id} value={it.name}>
                                    {it.name}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </FormControl>
            }

            <FormControl
                as={SimpleGrid}
                columns={{ base: 2, lg: 4, xl: 4 }}
                bg="white"
                p="5"
                mt="5"
                gap={20}
                alignItems={"center"}
            >
                {!startDate || !endDate ?
                    <FormLabel htmlFor="startField">
                        Debes seleccionar ambas fechas
                    </FormLabel>
                    :
                    null
                }
                <FormLabel htmlFor="startField">
                    Fecha de inicio
                </FormLabel>
                <Input
                    id="startField"
                    type="date"
                    placeholder="Fecha de inicio"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                <FormLabel htmlFor="startField">
                    Fecha de fin
                </FormLabel>
                <Input
                    id="startField"
                    type="date"
                    placeholder="Fecha de inicio"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </FormControl>
            <FormControl
                as={SimpleGrid}
                columns={{ base: 1, lg: 1, xl: 1 }}
                bg="white"
                p="5"
                mt="5"
            >
                <CheckboxGroup value={selectedCheck} onChange={setSelectedCheck} >
                    <Stack justifyContent={'space-between'} direction="row">
                        <SimpleGrid columns={4} spacing={2} justifyContent={'space-between'} width={"100%"}>
                            <Checkbox borderRadius={"50px"} value="computerHardware">Equipo de Computo</Checkbox>                                                 
                            <Checkbox borderRadius={"50px"}  value="area">Cargo</Checkbox>                                                       
                            {relationData.map((campo: any) => (
                                <Checkbox key={campo.dato} value={campo.dato} borderRadius="50px">
                                    {campo.name}
                                </Checkbox>
                            ))}
                        </SimpleGrid>
                    </Stack>
                </CheckboxGroup>
            </FormControl>
            <ButtonGroup
                margin={"20px auto"}
                width={"100%"}
            >
                <Menu>
                    <MenuButton
                        isLoading={isExporting}
                        as={Button}
                        width={"220px"}
                        margin={"auto"}
                        onClick={handleFetchLogs}
                    >
                        Descargar
                    </MenuButton>
                    {selectedValues === "salario" ?
                        <MenuList>
                            <MenuItem
                                command="⌘T"
                                icon={<FaFileExcel />}
                                onClick={() => customExportSalary("xlsx")}
                            >
                                Exportar RS como xlsx
                            </MenuItem>
                            <MenuItem
                                icon={<FaFileExcel />}
                                onClick={() => customExportSalary("csv")}
                            >
                                Exportar RS como cvs
                            </MenuItem>
                        </MenuList>

                        :


                        <MenuList>
                            <MenuItem
                                command="⌘T"
                                icon={<FaFileExcel />}
                                onClick={() => {customExportRole("xlsx") 
                                    setSelectArea("") 
                                    setSelectSubArea("")} }
                            >
                                Exportar RR como xlsx
                            </MenuItem>
                            <MenuItem
                                icon={<FaFileExcel />}
                                onClick={() => {customExportRole("csv") 
                                                setSelectArea("") 
                                                setSelectSubArea("")} }
                            >
                                Exportar RR como cvs
                            </MenuItem>
                        </MenuList>
                    }

                </Menu>
            </ButtonGroup>
        </Box>

    )
}
